import { createFileRoute } from '@tanstack/react-router'
import ImportPrices from 'Administration/components/import/Prices/ImportPrices'

import AdministrationPage from '../../-administrationPage'
import { Guard, adminClaims } from '../../-guard'

export const Route = createFileRoute('/administration/imports/importprices')({
    component: () => (
        <Guard claims={adminClaims}>
            <AdministrationPage>
                <ImportPrices />
            </AdministrationPage>
        </Guard>
    ),
})
